<template>
    <v-flex-container center>
        <v-card-container>
            <div v-padding.left="2" v-padding.right="2" v-padding.bottom="2" v-padding.top="2">
                <v-row justify-content="center">
                    <v-col v-text-align.center>
                        <v-text type="subheadling" v-if="isRegister" bold>
                            Регистрация
                        </v-text>
                        <v-router-link v-else size="subheadling" :to="{ name: 'register' }">
                            Регистрация
                        </v-router-link>
                    </v-col>
                    <v-col v-text-align.center>
                        <!-- <v-text type="subheadling" v-if="isDemo" bold>
                            Демо-доступ
                        </v-text>

                        <v-router-link v-else size="subheadling" :to="{ name: 'demo' }">
                            Демо-доступ
                        </v-router-link> -->
                    </v-col>
                    <v-col v-text-align.center>
                        <v-text type="subheadling" v-if="isLogin" bold>
                            Вход
                        </v-text>

                        <v-router-link v-else size="subheadling" :to="{ name: 'login' }">
                            Вход
                        </v-router-link>
                    </v-col>
                </v-row>
            </div>
        </v-card-container>
    </v-flex-container>
</template>
<script>
import {
    vCardContainer,
    vFlexContainer,
} from './baseComponents';

export default {
    name: 'mobile-navigation',
    data() {
        return {
            route: this.$route.name,
        };
    },
    components: {
        vCardContainer,
        vFlexContainer,
    },
    computed: {
        isRegister() {
            return this.route === 'register';
        },
        isLogin() {
            return this.route === 'login';
        },
        isDemo() {
            return this.route === 'demo';
        }
    }
}
</script>



// WEBPACK FOOTER //
// MobileNaigation.vue?791a9cf2